// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__1QSs2","tabs":"home_tabs__3hMiU","tab":"home_tab__qyeOc","indicator":"home_indicator__1IY0P"};